import 'phaser'
import {
    CST
} from '../CST'

export default class Preload extends Phaser.Scene {

    constructor() {
        super(CST.SCENES.PRELOAD);
    }

    preload() {
        // Sounds
        this.load.audio("click-sound", "assets/sounds/click.mp3");
        this.load.audio("congratulations-sound", "assets/sounds/congratulations.mp3");
        this.load.audio("correct-sound", "assets/sounds/correct.mp3");
        this.load.audio("wrong-sound", "assets/sounds/wrong.mp3");
        this.load.audio("timer-sound", "assets/sounds/timer.mp3");
        this.load.audio("pop-sound", "assets/sounds/pop.mp3");
        this.load.audio("pawn-moving-sound", "assets/sounds/pawn-moving.mp3");
        this.load.audio("dice-rolling-sound", "assets/sounds/dice-rolling.mp3");
        this.load.audio("bubbles-music", "assets/sounds/bubbles-music.mp3");

        // Menu Background
        this.load.image('menu-bg', "assets/menu_screen.png")

        // questionnare assets
        this.load.image('generic-bg', 'assets/questionnaire/generic_background.png');
        this.load.image('questionnaire-bg', 'assets/questionnaire/questionnaire_background.png');
        this.load.image('character-intro', 'assets/questionnaire/character_intro.png');
        this.load.image('character-outro', 'assets/questionnaire/character_outro.png');
        this.load.image('intro-popup', 'assets/questionnaire/intro_popup.png');
        this.load.image('outro-popup', 'assets/questionnaire/outro_popup.png');
        this.load.image('questionnaire-popup', 'assets/questionnaire/questionnaire_popup.png');
        this.load.image('outro-step1-1', 'assets/questionnaire/step1-outro1.png');
        this.load.image('outro-step1-2', 'assets/questionnaire/step1-outro2.png');
        this.load.image('outro-step1-3', 'assets/questionnaire/step1-outro3.png');
        this.load.image('outro-step2-1', 'assets/questionnaire/step2-outro1.png');
        this.load.image('outro-step2-2', 'assets/questionnaire/step2-outro2.png');
        this.load.image('outro-step2-3', 'assets/questionnaire/step2-outro3.png');
        this.load.image('outro-step3-1', 'assets/questionnaire/step3-outro1.png');
        this.load.image('outro-step3-2', 'assets/questionnaire/step3-outro2.png');
        this.load.image('outro-step3-3', 'assets/questionnaire/step3-outro3.png');
        this.load.image('outro-step4-1', 'assets/questionnaire/step4-outro1.png');
        this.load.image('outro-step4-2', 'assets/questionnaire/step4-outro2.png');
        this.load.image('outro-step4-3', 'assets/questionnaire/step4-outro3.png');
        this.load.image('outro-step5-1', 'assets/questionnaire/step5-outro1.png');
        this.load.image('outro-step5-2', 'assets/questionnaire/step5-outro2.png');
        this.load.image('outro-step5-3', 'assets/questionnaire/step5-outro3.png');
        this.load.image('questionnaire-outro', 'assets/questionnaire/questionnaire_outro.png');

        //  buttons 
        this.load.image('menu-button', 'assets/buttons/menu_button.png');
        this.load.image('menu-button-bubbles', 'assets/buttons/menu_button_bubble.png');
        this.load.image('menu-button-hover', 'assets/buttons/menu_button_hover.png');
        this.load.image('next-button', 'assets/buttons/next_button.png');
        this.load.image('next-button-hover', 'assets/buttons/next_button_hover.png');
        this.load.image('next-button-orange', 'assets/buttons/next_button_orange.png');
        this.load.image('next-button-orange-hover', 'assets/buttons/next_button_orange_hover.png');
        this.load.image('next-button-orange-small', 'assets/buttons/next_button_orange_small.png');
        this.load.image('next-button-orange-small-hover', 'assets/buttons/next_button_orange_small_hover.png');
        this.load.image('next-button-small', 'assets/buttons/next_button_small.png');
        this.load.image('next-button-small-hover', 'assets/buttons/next_button_small_hover.png');
        this.load.image('pause-button', 'assets/buttons/pause_button.png');
        this.load.image('pause-button-hover', 'assets/buttons/pause_button_hover.png');
        this.load.image('pause-button-orange', 'assets/buttons/pause_button_orange.png');
        this.load.image('pause-button-orange-hover', 'assets/buttons/pause_button_orange_hover.png');
        this.load.image('pause-button-orange-small', 'assets/buttons/pause_button_orange_small.png');
        this.load.image('pause-button-orange-small-hover', 'assets/buttons/pause_button_orange_small_hover.png');
        this.load.image('pause-button-small', 'assets/buttons/pause_button_small.png');
        this.load.image('pause-button-small-hover', 'assets/buttons/pause_button_small_hover.png');
        this.load.image('play-button', 'assets/buttons/play_button.png');
        this.load.image('previous-button', 'assets/buttons/previous_button.png');
        this.load.image('previous-button-hover', 'assets/buttons/previous_button_hover.png');
        this.load.image('previous-button-orange', 'assets/buttons/previous_button_orange.png');
        this.load.image('previous-button-orange-hover', 'assets/buttons/previous_button_orange_hover.png');
        this.load.image('previous-button-orange-small', 'assets/buttons/previous_button_orange_small.png');
        this.load.image('previous-button-orange-small-hover', 'assets/buttons/previous_button_orange_small_hover.png');
        this.load.image('previous-_button-small', 'assets/buttons/previous_button_small.png');
        this.load.image('previous-button-small-hover', 'assets/buttons/previous_button_small_hover.png');
        this.load.image('setting-button', 'assets/buttons/setting_button.png');
        this.load.image('setting-button-orange', 'assets/buttons/setting_button_orange.png');
        this.load.image('sound-off-button', 'assets/buttons/sound_off_button.png');
        this.load.image('sound-off-button-blue', 'assets/buttons/sound_off_button_blue.png');
        this.load.image('sound-on-button', 'assets/buttons/sound_on_button.png');
        this.load.image('sound-on-button-blue', 'assets/buttons/sound_on_button_blue.png');
        this.load.image('bubble-button', 'assets/buttons/bubble_button.png');
        this.load.image('questionnaire-button', 'assets/buttons/questionnaire_button.png');
        this.load.image('replay-btn', 'assets/buttons/replay-btn.png');
        this.load.image('feedback-btn', 'assets/buttons/feedback-btn.png');
        this.load.image('feedback-btn-2', 'assets/buttons/feedback-btn2.png');
        this.load.spritesheet({
            key: 'sound-btn',
            url: 'assets/buttons/sound-btn.png',
            frameConfig: {
                frameWidth: 136,
                frameHeight: 136
            }
        })

        // Bubbles assets 
        this.load.image('buuble-bg', 'assets/bubbles/background.png');
        this.load.image('buuble-overlay', 'assets/bubbles/bubble overlay.png');
        //this.load.image('booble', 'assets/bubbles/booble1.png');
        //this.load.image('booble-2', 'assets/bubbles/booble2.png');
        this.load.image('explosion', 'assets/bubbles/explosion.png');
        this.load.image('sexist-popup', 'assets/bubbles/sexist_popup.png');
        this.load.image('not-sexist_popup', 'assets/bubbles/notsexist_popup.png');
        this.load.image('bubble-intro', 'assets/bubbles/bubble_intro.png');
        this.load.image('bubble-outro', 'assets/bubbles/bubble_outro.png');
        this.load.image('time-up', 'assets/bubbles/time_up.png');

        this.load.spritesheet({
            key: 'small-sprite-sexist',
            url: 'assets/bubbles/small-sprite-sexist.png',
            frameConfig: {
                frameWidth: 214.16,
                frameHeight: 214
            }
        })

        this.load.spritesheet({
            key: 'regular-sprite-sexist',
            url: 'assets/bubbles/regular-sprite-sexist.png',
            frameConfig: {
                frameWidth: 214.06,
                frameHeight: 214
            }
        })

        this.load.spritesheet({
            key: 'large-sprite-sexist',
            url: 'assets/bubbles/large-sprite-sexist.png',
            frameConfig: {
                frameWidth: 214.07,
                frameHeight: 214
            }
        })

        this.load.spritesheet({
            key: 'small-sprite-nonsexist',
            url: 'assets/bubbles/small-sprite-nonsexist.png',
            frameConfig: {
                frameWidth: 214.33,
                frameHeight: 214
            }
        })

        this.load.spritesheet({
            key: 'regular-sprite-nonsexist',
            url: 'assets/bubbles/regular-sprite-nonsexist.png',
            frameConfig: {
                frameWidth: 214.07,
                frameHeight: 214
            }
        })

        this.load.spritesheet({
            key: 'large-sprite-nonsexist',
            url: 'assets/bubbles/large-sprite-nonsexist.png',
            frameConfig: {
                frameWidth: 214.06,
                frameHeight: 214
            }
        })

        this.load.spritesheet({
            key: 'burst-sprite-sexist',
            url: 'assets/bubbles/burst-sprite-sexist.png',
            frameConfig: {
                frameWidth: 238.25,
                frameHeight: 240
            }
        })

        this.load.spritesheet({
            key: 'burst-sprite-nonsexist',
            url: 'assets/bubbles/burst-sprite-nonsexist.png',
            frameConfig: {
                frameWidth: 238.25,
                frameHeight: 240
            }
        })

        this.load.spritesheet({
            key: 'checkbox-sprite',
            url: 'assets/questionnaire/checkbox_sprite.png',
            frameConfig: {
                frameWidth: 93.5,
                frameHeight: 96
            }
        })

        this.load.spritesheet({
            key: 'pin-sprite',
            url: 'assets/bubbles/pin.png',
            frameConfig: {
                frameWidth: 93.5,
                frameHeight: 156
            }
        })

        this.load.on('complete', () => {
            this.scene.start(CST.SCENES.MENU);
        });
    }


}